import { NavListItem, NavListItemToolTipContent } from '@procureai/ui-mui';
import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate, useMatch } from 'react-router-dom';

import { RouteId } from '~/routes';
import { initials } from '~/util/string';

import { NavListItemAvatarStyled } from './NavListItemAvatar.styled';

export const NavListItemAvatar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const profileRoute = RouteId.userProfile('');
  const match = !!useMatch({ path: profileRoute, end: true });

  const userInitials = useMemo(() => {
    return user ? initials([user.profile.given_name, user.profile.family_name]) : '';
  }, [user]);

  if (!user) {
    return null;
  }

  return (
    <NavListItem
      onClick={() => navigate(profileRoute)}
      tooltip={<NavListItemToolTipContent label={user.profile.name} />}
    >
      <NavListItemAvatarStyled isActive={match} alt={user?.profile.name}>
        {userInitials}
      </NavListItemAvatarStyled>
    </NavListItem>
  );
};
